import {
    getRequest,
    postRequest,
} from "../fetchWrapper";

/**
 * Récupération des infos des villes côté admin.
 *
 * @param string token Jeton d'authentification.
 * @param int pageNumber Numéro de page.
 * @param int limit Nombre d'items par requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCityList = (token, pageNumber, limit) => {
    const url = `/api-v1/admin/city/${pageNumber}/${limit}/list`
    return getRequest(url, token)
}

/**
 * Récupération des villes par code postal.
 *
 * @param auth Jeton d'authentification.
 * @param zip Code postal.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCityListSuggestByZip = (body, token) => {
    const url = `/api-v1/funedata/city/zip/suggest`
    return postRequest(url, body, token)
}

/**
 * Récupération des infos des villes par nom.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCityListSuggestByName = (body, token) => {
    const url = `/api-v1/funedata/city/name/suggest`
    return postRequest(url, body, token)
}

/**
 * Récupération des agences par code postal.
 *
 * @param auth Jeton d'authentification.
 * @param zip Code postal.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyListByZip = (body, token) => {
    const url = `/api-v1/funedata/establishment/zip/search`
    return postRequest(url, body, token)
}

/**
 * Récupération des agences par nom.
 *
 * @param auth Jeton d'authentification.
 * @param name Nom de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyListByName = (body, token) => {
    const url = `/api-v1/funedata/establishment/city/search`
    return postRequest(url, body, token)
}

/**
 * Récupération des infos d'un établissement par id.
 *
 * @param auth Jeton d'authentification.
 * @param id Id de l'établissement.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getEstablishmentById = (body, token) => {
    const url = `/api-v1/funedata/establishment/id/search`
    return postRequest(url, body, token)
}

/**
 * Update des infos d'un établissement.
 *
 * @param auth Jeton d'authentification.
 * @param body Infos de l'établissement.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const setEstablishmentInfos = (body, auth) => {
    const url = `api-v1/admin/agency/new`
    return postRequest(url, body, auth)
}